import styled, { css } from 'styled-components';

export const GroupInput = styled.fieldset`
  ${({ grid }) => css`
    //margin-top: 2rem;

    margin-top: 1rem;
    margin-bottom: 1.5rem;

    padding: 1rem;

    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;

    > legend {
      padding: 0 2rem;

      color: rgba(0, 0, 0, 0.6);
    }

    .__container {
      margin-top: 1rem;

      display: grid;
      gap: 2rem;
    }

    ${grid &&
    css`
      .__container {
        grid-template-columns: repeat(2, 1fr);

        @media (max-width: 425px) {
          grid-template-columns: repeat(1, 1fr);
        }
      }
    `}
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

